module.exports = __webpack_public_path__ + "static/media/what_students_say.8764aa4e.png";